import React, { useState, useEffect } from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import Dialog from '~/components/Dialog';

// Modal que embarca a interface da Mevo (Receita Digital) via iframe.
// Abre em fullscreen e o iframe preenche o espaço útil.
// Mostra um loading por 3s ao abrir, cobrindo o tempo inicial de carga do iframe.
// O botão "X" (fechar) do cabeçalho chama handleClose, que fecha o modal e
// revalida a lista de receitas (webhook é a fonte da verdade).
function MevoPrescriptionModal({
  isOpen,
  modalUrl,
  handleClose,
  onFinalized,
  onExcluded,
}) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // A interface da Mevo emite eventos via postMessage quando o médico age:
  //   Type: 'prescricao' -> receita FINALIZADA (evento final)
  //   Type: 'excluded'   -> receita excluída
  //   Type: 'cancel'     -> "terminar mais tarde" (segue iniciada)
  // Sem escutar isto, o modal só fechava no "X" e o status ficava preso em
  // "iniciada" (dependia só do webhook).
  useEffect(() => {
    if (!isOpen) return undefined;
    function onMessage(event) {
      // segurança: só aceita mensagens vindas do domínio da Mevo
      if (!/nexodata\.com\.br|mevosaude\.com\.br/.test(event.origin)) return;
      let data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      const type = data && (data.Type || data.type);
      if (!type) return;
      if (type === 'prescricao') {
        if (onFinalized) onFinalized();
        else handleClose();
      } else if (type === 'excluded') {
        if (onExcluded) onExcluded();
        else handleClose();
      } else if (type === 'cancel') {
        handleClose();
      }
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [isOpen, handleClose, onFinalized, onExcluded]);

  return (
    <Dialog
      icon={<LocalHospitalIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title="Receita Digital (Mevo)"
      maxWidth="lg"
      defaultFullScreen
    >
      <Box
        style={{
          position: 'relative',
          width: '100%',
          minWidth: 900,
          height: 'calc(100vh - 80px)',
        }}
      >
        {loading && (
          <Box
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 12,
              backgroundColor: '#fff',
              zIndex: 2,
            }}
          >
            <CircularProgress />
            <Typography style={{ color: '#666' }}>
              Carregando Receita Digital…
            </Typography>
          </Box>
        )}

        {modalUrl && (
          <iframe
            title="Mevo Receita Digital"
            src={modalUrl}
            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            allow="camera; microphone; clipboard-write; clipboard-read"
          />
        )}
      </Box>
    </Dialog>
  );
}

export default MevoPrescriptionModal;
